module.exports = __webpack_public_path__ + "images/emoji/grapes.aef574d85b910a8aa79b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/grapes.png
// module id = Unny
// module chunks = 1